module.exports = __webpack_public_path__ + "static/media/jdrManoir_03_thumb_hover.ec43473b.png";